// extracted by mini-css-extract-plugin
export var dropdownButton = "_2e-0";
export var fullWidthDropdownButton = "_2e-1";
export var icon = "_2e-3";
export var iconPlaceholder = "_2e-2";
export var menuItemRow = "_2e-5";
export var shortcutContainer = "_2e-4";